import React, { useState } from "react";
import Container from "./Container";
import ImageModal from "./ImageModal";
import "./Galery.css";

// CRA / Webpack compatible
const imagesContext = require.context(
  "../img/galery",
  false,
  /\.(png|jpe?g|webp)$/i
);

const images = imagesContext.keys().map(imagesContext);

export default function Galery() {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <Container>
            <h1 className="gallery-title">Galéria</h1>

            <div className="gallery-grid">
                {images.map((src, index) => (
                    <div
                        className="gallery-item"
                        key={index}
                        onClick={() => setSelectedImage(src)}
                    >
                        <img src={src} alt={`Gallery ${index + 1}`} />
                    </div>
                ))}
            </div>

            {/* Fullscreen image modal */}
            <ImageModal
                image={selectedImage}
                isOpen={!!selectedImage}
                onClose={() => setSelectedImage(null)}
            />
        </Container>
    );
}
